import $ from 'jquery';
import H from "@here/maps-api-for-javascript";

export class Here{
    constructor(){
        this.platform = new H.service.Platform({
            apikey: 'lcvIRMX6-hy1whjlS-43Z3S8r1AtyIZ9mdLh6NlAMm0'
        });
        this.coords = [];
        this.red_path_coords = [];
        this.markers = [];
        this.map;
        this.last_coord_driver;
        this.path_exec_interval;
        this.path_exec_interval_sec;
        this.path_current_position = 0;
        this.path_points_length;
        this.is_walkThroughRoute_init = false;
        this.is_path_being_exec = false;
        this.walkThroughRoute_data = [];
        this.walkThroughRoute_dataBackup = [];        
        this.walkThroughRoute_provider;
        this.walkThroughRoute_layer;
    }

    createMap(id){
        this.defaultLayers = this.platform.createDefaultLayers();
        // Instantiate (and display) a map object:
        this.map = new H.Map(
            document.getElementById(id),
            this.defaultLayers.vector.normal.map,
            {
                zoom: 10, //default
                center: { lat: 0, lng: 0 } //default
        });
    }
    
    centerMap(coords){
        if(coords.length > 0){
            this.map.setViewBounds(
                H.geo.Rect.coverPoints(coords)
            );
        } else {
            // Centraliza no mapa do Brasil, se não há nada em coords
            this.map.setCenter({lat:-15.794266, lng:-47.887890});
            this.map.setZoom(4);
        }
    }
    
    createIcon(type, config){    
        var image;    
        if(type === 'point'){
            image = this.createPoint(config['bg_color'], config['position']);
        } else if(type === 'stop'){
            image = this.createPin(config['bg_color'], config['text']);
        } else if(type === 'vehicle'){
            image = this.createTruck(config['bg_color']);
        } else if(type === 'base_origin'){
            image = this.createOrigin();
        } else if(type === 'base_dest'){
            image = this.createDestination();
        } else if(type === 'arrive'){
            image = this.createArrive(config['bg_color'], config['text_color'], config['count']);
        } else if(type === 'start'){
            image = this.createStart(config['bg_color'], config['text_color'], config['count']);
        } else if(type === 'base' || type === 'transito' || type === 'pendente'){
            image = this.createTruckSync(type);
        }else if(type === 'pause' || type === 'occurrence'){
            image = this.createPin(config['bg_color'], config['text']);
        }
    
        var icon = new H.map.DomIcon(image, {});
        
        return icon;
    }

    createPoint(bgColor, position){
        let html;
        switch (position) {
            case "first":
                // if(bgColor !== undefined) {
                //     html = `<div style='display: table; cursor: help;'>
                //         <div class='first-point-pin' style='background-color: ${bgColor};
                //             -webkit-mask: url("${window.app.webroot}img/first_last_point.svg") no-repeat center; 
                //             mask: url("${window.app.webroot}img/first_last_point.svg");
                //             -webkit-mask-size: 30px 30px;'>
                //         </div>
                //     </div>`;
                // } else {
                    html = `<div style='display: table; cursor: help;'>
                        <div class='first-point-pin' style='
                            -webkit-mask: url("${window.app.webroot}img/first_last_point.svg") no-repeat center; 
                            mask: url("${window.app.webroot}img/first_last_point.svg");
                            -webkit-mask-size: 30px 30px;'>
                        </div>
                    </div>`;   
                // }       
                break;
            case "last":
                // if(bgColor !== undefined) {
                //     html = `<div style='display: table; cursor: help;'>
                //         <div class='last-point-pin' style='background-color: ${bgColor};
                //             -webkit-mask: url("${window.app.webroot}img/first_last_point.svg") no-repeat center; 
                //             mask: url("${window.app.webroot}img/first_last_point.svg");
                //             -webkit-mask-size: 30px 30px;'>
                //         </div>
                //     </div>`;
                // } else {
                    html = `<div style='display: table; cursor: help;'>
                        <div class='last-point-pin' style='
                            -webkit-mask: url("${window.app.webroot}img/first_last_point.svg") no-repeat center; 
                            mask: url("${window.app.webroot}img/first_last_point.svg");
                            -webkit-mask-size: 30px 30px;'>
                        </div>
                    </div>`;   
                // }       
                break;
            default:
                if(bgColor !== undefined) {
                    html = `<div style='display: table; cursor: help;'>
                        <div class='point-pin' style='background-color: ${bgColor};
                            -webkit-mask: url("${window.app.webroot}img/circle.svg") no-repeat center; 
                            mask: url("${window.app.webroot}img/circle.svg");
                            -webkit-mask-size: 12px 12px;'>
                        </div>
                    </div>`;
                } else {
                    html = `<div style='display: table; cursor: help;'>
                        <div class='point-pin' style='
                            -webkit-mask: url("${window.app.webroot}img/circle.svg") no-repeat center; 
                            mask: url("${window.app.webroot}img/circle.svg");
                            -webkit-mask-size: 12px 12px;'>
                        </div>
                    </div>`;    
                }                
                break;
        }

        return html;
    }

    createPin(bgColor, text){
        if(bgColor !== undefined && text !== undefined)
            return `<div style='display: table;'>
                <div class='pin' style='background-color: #${bgColor}; 
                    -webkit-mask: url("${window.app.webroot}img/pin.svg") no-repeat center; 
                    mask: url("${window.app.webroot}img/pin.svg");
                    -webkit-mask-size: 35px 47.712px;'>
                    <div>${text}</div>
                </div>
            </div>`;
        if(text !== undefined)
            return `<div style='display: table;'>
                <div class='pin' style='background-image: url("${window.app.webroot}img/pin.svg");
                    background-size: 35px 47.712px;'>
                    <div>${text}</div>
                </div>
            </div>`;
        if(bgColor !== undefined)
            return `<div style='display: table;'>
                <div class='pin' style='background-color: #${bgColor}; 
                    -webkit-mask: url("${window.app.webroot}img/pin-normal.svg") no-repeat center; 
                    mask: url("${window.app.webroot}img/pin-normal.svg");
                    -webkit-mask-size: 35px 47.712px;'>
                </div>
            </div>`;

        return `<div style='display: table;'>
            <div class='pin' style='background-image: url("${window.app.webroot}img/pin-normal.svg");
                background-size: 35px 47.712px;'></div>
        </div>`; 
    }

    createTruck(bgColor){
        return `<div style='display: table;'>
            <div class='truck-pin' style='background-color: #${bgColor}; 
                -webkit-mask: url("${window.app.webroot}img/truck-solid.svg") no-repeat center; 
                mask: url("${window.app.webroot}img/truck-solid.svg");
                -webkit-mask-size: 35px 26.5px;'>
            </div>
        </div>`;
    }

    createTruckSync(type){
        var imagem,color;
        if(type === "base"){
            imagem = "caminhao_verde.svg"
            color = "#FFC125"
        } else if(type === "pendente"){
            imagem = "caminhao_amarelo.svg"
            color = "#FFC125"
        } else if(type === "transito"){
            imagem = "caminhao_azul.svg"
            color = "#FFC125"
        }
        // <div class='truck-pin' style='background-color: black; background-image: url("${window.app.webroot}img/truck-regular.svg") no-repeat center;' 

        return `<div style='display: table;'>
            <div class='truck-pin' style='background-color: ${color}; 
                -webkit-mask: url("${window.app.webroot}img/${imagem}") no-repeat center; 
                mask: url("${window.app.webroot}img/${imagem}");
                -webkit-mask-size: 35px 26.5px;'>
            </div>
        </div>`
    }

    createOrigin(){
        return `<div style='display: table;'>
            <div class='base-pin' style='background: url("${window.app.webroot}img/warehouse.svg") no-repeat center;
                background-size: 30px 30px;'>
            </div>
        </div>`;
    }

    createDestination(){
        return `<div style='display: table;'>
            <div class='base-pin' style='background: url("${window.app.webroot}img/pin-checkered.svg") no-repeat center;
                background-size: 30px 30px;'>
            </div>
        </div>`;
    }

    createArrive(bgColor, textColor, text){
        return `<div class='arrive-pin' style='background-color: #${bgColor}; color: #${textColor}'>${text}</div>`
    }
    
    createStart(bgColor, textColor, text){
        return `<div class='start-pin' style='background-color: #${bgColor}; color: #${textColor}'>${text}</div>`
    }
    
    createMarker(coords, icon){
        var marker = new H.map.DomMarker(coords, {icon: icon});
        return marker;
    }

    createBubbleEventHandler(group){
        let $this = this;
        // add 'tap' event listener, that opens info bubble, to the group
        var bubble;
        group.addEventListener('pointerenter', { passive: true }, function (evt) {
            // event target is the marker itself, group is a parent event target
            // for all objects that it contains
            bubble =  new H.ui.InfoBubble(evt.target.getPosition(), {
                // read custom data
                content: evt.target.getData().html
            });
            // show info bubble
            $this.ui.addBubble(bubble);
        }, false);
        group.addEventListener('pointerleave', { passive: true }, function () {
            // event target is the marker itself, group is a parent event target
            // for all objects that it contains
            bubble
            // show info bubble
            $this.ui.removeBubble(bubble);
        }, false);
    }
    
    getBubbleHtml(type, value){
        let html = '';
        switch(type){
            case 'homepage':
                html = `<div class='map-overlay-box'>
                        <p class='font-weight-bold'>${value['number']} - ${value['date']}</p>
                        Motorista: ${value['driver']}<br />
                        Placa: ${value['numberplate']}<br />
                        Telefone: ${value['driver_phone']}<br />
                        Status: ${value['status_description']}<br />
                        Ultima sincronização: ${value['last_sync']}</p>`

                if(value['to_base'] === 'dest'){
                    if(value['base_code']){
                        html += `<p>${value['base_street']}, ${value['base_house_number']}, ${value['base_district']}, ${value['base_city']} - ${value['base_state']}</p>`;
                    } else { html += `<p>Sem base</p>`; }
                } else{
                    if(value['base_o_code']){
                        if(value['base_code']){
                            html += `<p>${value['base_o_street']}, ${value['base_o_house_number']}, ${value['base_o_district']}, ${value['base_o_city']} - ${value['base_o_state']}</p>`;
                        } else { html += `<p>Sem base</p>`; }
                    }
                }
                html += `</div>`;
                break;
        }

        return html;
    }

    //return a workable RGB int array [r,g,b] from hex representation
    processHEX(val) {
        //does the hex contain extra char?
        var hex = (val.length >6)?val.substr(1, val.length - 1):val;
        var r,g,b;

        // is it a six character hex?
        if (hex.length > 3) {    
            //scrape out the numerics
            r = hex.substr(0, 2);
            g = hex.substr(2, 2);
            b = hex.substr(4, 2);    
        // if not six character hex,
        // then work as if its a three character hex
        } else {    
            // just concat the pieces with themselves
            r = hex.substr(0, 1) + hex.substr(0, 1);
            g = hex.substr(1, 1) + hex.substr(1, 1);
            b = hex.substr(2, 1) + hex.substr(2, 1);    
        }
        // return our clean values
        return [
            parseInt(r, 16),
            parseInt(g, 16),
            parseInt(b, 16)
        ]
    }

    pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }
  
    getColorsArray(length, context) {  
        // var val1RGB = context.processHEX("#0064ff");
        // var val2RGB = context.processHEX("#363636");
        var val1RGB = context.processHEX("#ffff00");
        var val2RGB = context.processHEX("#ff0c00");
        var colors = [];
  
        //the number of steps in the gradient
        var stepsInt = length;
        //the percentage representation of the step
        var stepsPerc = 100 / (stepsInt+1);
    
        // diffs between two values 
        var valClampRGB = [
            val2RGB[0] - val1RGB[0],
            val2RGB[1] - val1RGB[1],
            val2RGB[2] - val1RGB[2]
        ];
        
        // build the color array out with color steps
        for (var i = 0; i < stepsInt; i++) {
            var clampedR = (valClampRGB[0] > 0) 
                ? context.pad((Math.round(valClampRGB[0] / 100 * (stepsPerc * (i + 1)))).toString(16), 2) 
                : context.pad((Math.round((val1RGB[0] + (valClampRGB[0]) / 100 * (stepsPerc * (i + 1))))).toString(16), 2);
            
            var clampedG = (valClampRGB[1] > 0) 
                ? context.pad((Math.round(valClampRGB[1] / 100 * (stepsPerc * (i + 1)))).toString(16), 2) 
                : context.pad((Math.round((val1RGB[1] + (valClampRGB[1]) / 100 * (stepsPerc * (i + 1))))).toString(16), 2);
            
            var clampedB = (valClampRGB[2] > 0) 
                ? context.pad((Math.round(valClampRGB[2] / 100 * (stepsPerc * (i + 1)))).toString(16), 2) 
                : context.pad((Math.round((val1RGB[2] + (valClampRGB[2]) / 100 * (stepsPerc * (i + 1))))).toString(16), 2);

            colors[i] = [
                '#',
                clampedR,
                clampedG,
                clampedB
            ].join('');
        }

        return colors;
    }   
    
    walkThroughRoute(red_path){
        var $this = Here();
        if (!this.is_walkThroughRoute_init) {
            this.is_walkThroughRoute_init = true;            
            var i;
            var points = red_path.split("|"), index = 0;
            for(i = 0; i < points.length; i++){
                var point = points[i].split(";");
                if(point.length === 2 && parseFloat(point[0]) === point[0] && parseFloat(point[1]) === point[1]) {
                    this.walkThroughRoute_data.push([index, point[0], point[1]]);
                    this.walkThroughRoute_dataBackup.push([index, point[0], point[1]]);
                    this.red_path_coords.push({lat: point[0], lng: point[1]})
                    index++;
                }
            }
            this.path_points_length = this.walkThroughRoute_data.length;

            // Até 60 pontos o intervalo padrão é de 1s
            if (this.path_points_length > 60) {
                this.path_exec_interval_sec = (60000 + (30000 * (this.path_points_length / 500))) / this.path_points_length;
            } else {
                this.path_exec_interval_sec = 1000;
            }
            this.centerMap(this.red_path_coords);            

            // create the provider
            this.walkThroughRoute_provider = new H.datalens.Provider();
            this.walkThroughRoute_provider.setData({
                columns: ['id', 'lat', 'lng'],
                rows: this.walkThroughRoute_data
            });

            // create the layer
            this.walkThroughRoute_layer = new H.datalens.ObjectLayer(this.walkThroughRoute_provider, {
                rowToMapObject: (row) => {                
                    return H.datalens.ObjectLayer.createReusableMarker(
                        row.id,
                        new H.geo.Point(row.lat, row.lng)
                    );
                },
                rowToStyle: (row) => {
                    let icon;
                    if (row.id === 0) {
                        icon = H.datalens.ObjectLayer.createIcon(
                            [
                                'svg',
                                {
                                    viewBox: '-20 -20 40 40'
                                },
                                [
                                    'circle',
                                    {
                                        r: 6,
                                        fill: '#F38630',
                                        stroke: '#000000'
                                    }
                                ]
                            ], {size: 70}
                        );    
                    } else {
                        icon = H.datalens.ObjectLayer.createIcon(
                            [
                                'svg',
                                {
                                    viewBox: '-20 -20 40 40'
                                },
                                [
                                    'circle',
                                    {
                                        r: 0
                                    }
                                ]
                            ], {size: 0}
                        );  
                    }
                    
                    return {icon};
                },
                transitionOptions: () => {
                    return {
                        duration: this.path_exec_interval_sec,
                        easing: 'linear',
                        interp: 'lerp'
                    };
                }
            });
            this.map.addLayer(this.walkThroughRoute_layer);

            setTimeout(updateMarkerPositions, 0);
            this.path_exec_interval = setInterval(updateMarkerPositions, this.path_exec_interval_sec);
            this.is_path_being_exec = true;
        } else {
            if (this.is_path_being_exec) {
                this.is_path_being_exec = false;

                this.walkThroughRoute_data = [];
                for(i = 0; i < this.walkThroughRoute_dataBackup.length; i++){
                    this.walkThroughRoute_data.push([i, this.walkThroughRoute_dataBackup[i][1], this.walkThroughRoute_dataBackup[i][2]]);
                }
                
                this.walkThroughRoute_provider.setData({
                    columns: ['id', 'lat', 'lng'],
                    rows: this.walkThroughRoute_data
                });                                            
                this.path_current_position = 0;                            

                clearInterval(this.path_exec_interval);
                setTimeout(function() {
                    $this.map.removeLayer($this.walkThroughRoute_layer);                    
                }, this.path_exec_interval_sec);                
            } else {
                this.is_path_being_exec = true;

                this.map.addLayer(this.walkThroughRoute_layer);

                this.path_exec_interval = setInterval(updateMarkerPositions, this.path_exec_interval_sec);
                this.centerMap(this.red_path_coords);
            }            
        }
        
        // update marker positions periodically
        function updateMarkerPositions() {
            if ($this.path_current_position < $this.path_points_length-1) {
                let data_copy = $this.walkThroughRoute_data.slice();
                let data_copy2 = [];

                data_copy2 = getNextPosition(data_copy);

                $this.walkThroughRoute_provider.setData({
                    columns: ['id', 'lat', 'lng'],
                    rows: data_copy2
                }); 
            } else {
                finishDriverPath();
            }   
        }

        function getNextPosition(data_copy) {
            while ((data_copy[0][1] === data_copy[$this.path_current_position][1]) && (data_copy[0][2] === data_copy[$this.path_current_position][2])) {
                $this.path_current_position++;
            }
            let lat = data_copy[0][1];
            let lng = data_copy[0][2];
            data_copy[0][1] = data_copy[$this.path_current_position][1];
            data_copy[0][2] = data_copy[$this.path_current_position][2];
            data_copy[$this.path_current_position][1] = lat;
            data_copy[$this.path_current_position][2] = lng;
            $this.path_current_position++;
            return data_copy;
        }
        
        function finishDriverPath(){
            let backup_path_exec_interval_sec = $this.path_exec_interval_sec;
            $this.path_exec_interval_sec = 3000;
            $this.walkThroughRoute(window.app.red_path);            
            $("#stop_driver_path").toggle("fast", function() {
                $("#label_finish_driver_path").toggle();
                setTimeout(function() {
                    $("#finish_counting").html($("#finish_counting").html().replace("3", "2"));
                    setTimeout(function() {
                        $("#finish_counting").html($("#finish_counting").html().replace("2", "1"));
                        setTimeout(function() {
                            $this.path_exec_interval_sec = backup_path_exec_interval_sec;
                            $("#label_finish_driver_path").toggle("fast", function() {      
                                $("#finish_counting").html($("#finish_counting").html().replace("1", "3"));
                                $("#label_play_driver_path").toggle();
                            });
                        }, 1000);
                    }, 1000);
                }, 1000);                                              
            });
        }
    }

    plotMarkers(markers, type = 'stop', showInfo = true){
        let coords = [], coord, icon;
        let $this = this; //save 'this' to use inside $.each
        var return_markers = [];
        
        if (type === "point") {     
            var colors, last;       
            colors = $this.getColorsArray(markers.length, $this);
            last = markers.length;
        }

        $.each(markers, function(key, value){
            if(typeof value === 'undefined'){return;} 
            if(value['lng'] && value['lat'] && (value['lng'] !== 0 && value['lat'] !== 0)){
                coord = {lat: value['lat'], lng: value['lng']};                
                coords.push(coord);
                if (type === "point") {
                    value['bg_color'] = colors[key];
                    if (key === 0 || key === last-1) {
                        value['position'] = "first";
                        value['bg_color'] = "#000";
                    }
                    if (key === last-1) {
                        value['position'] = "last";
                        value['bg_color'] = "#000";
                    }
                } 
                icon = $this.createIcon(type, value);                
                let marker = $this.createMarker(coord, icon);
                return_markers.push(marker);
                let group = new H.map.Group();
                $this.map.addObject(group);
                $this.createBubbleEventHandler(marker);
                if(showInfo){
                    let html = $this.getBubbleHtml('homepage', value);
                    if(value['id']){
                        marker.setData({id: value['id'], html});
                    } else {
                        marker.setData({html});
                    }
                }
                group.addObject(marker);
                $this.markers.splice(value['id'], 0, marker);
            }
        });
        if(coords.length > 0) this.coords = this.coords.concat(coords);
        return return_markers;
    }

    createControllers(showControls = true){
        //CONTROLES
        var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));
        this.ui = H.ui.UI.createDefault(this.map, this.defaultLayers, 'pt-BR');

        var mapSettings = this.ui.getControl('mapsettings');
        var zoom = this.ui.getControl('zoom');
        var scalebar = this.ui.getControl('scalebar');

        zoom.setVisibility(showControls);
        mapSettings.setVisibility(showControls);
        scalebar.setVisibility(showControls);
        
        mapSettings.setVisibility(false);
        zoom.setAlignment('top-left');
        scalebar.setAlignment('top-left');
        //FIM CONTROLES
    }

    

    createPolyLine(path, strokeColor, lineWidth = 5){

        // var poly;
        if(path){
            var i;
            var points = path.split("|");
            var length = points.length;

            var linestring = new H.geo.LineString();
            
            for(i = 0; i < length; i++){
                var point = points[i].split(";");
                if(point.length === 2 && parseFloat(point[0]) === point[0] && parseFloat(point[1]) === point[1]) {
                    linestring.pushPoint({lat: point[0], lng: point[1]});
                }
            }

            var fillColor = '#000000';
            
            // Initialize a polyline with the linestring:
            if(linestring.getPointCount() > 1) {
                var polyline = new H.map.Polyline(linestring, { style: { lineWidth, strokeColor}, arrows: {
                    width: 2,
                    length: 3,
                    fillColor: fillColor
                }});
            
                // Add the polyline to the map:
                this.map.addObject(polyline);
                
                // Zoom the map to make sure the whole polyline is visible:
                this.map.setViewBounds(polyline.getBounds());
            }

        }
    
        return polyline;
    }

    createFences(originMarker, destMarker){
        if(typeof window.app.radius !== 'string') return;
        let $this = this;
        var return_fences = [];
        $.each($this.markers, function(){
            var circle = new H.map.Circle(
                this.getPosition(), 
                window.app.radius,
                {style: {fillColor: 'rgba(0, 0, 0, 0)'}}
            );
            return_fences.push(circle);
            $this.map.addObject(circle);
        });

        // Add de cerca à origem
        if (originMarker !== undefined) {
            let originCircle = new H.map.Circle(
                originMarker.getPosition(), 
                window.app.radius,
                {style: {fillColor: 'rgba(0, 0, 0, 0)'}}
            );
            return_fences.push(originCircle);
            $this.map.addObject(originCircle);
        }        

        // Add de cerca ao destino
        if (destMarker !== undefined) {
            let destCircle = new H.map.Circle(
                destMarker.getPosition(), 
                window.app.radius,
                {style: {fillColor: 'rgba(0, 0, 0, 0)'}}
            );
            return_fences.push(destCircle);
            $this.map.addObject(destCircle);
        }

        return return_fences;
    }

    shakePin(id){  
        let $this = this;
        $.each(this.markers, function(key, value){
            value.setZIndex(1);
            if(value.getData().id === id){
                $this.map.setCenter(this.getPosition());
                $this.map.setZoom(18);
                value.setZIndex(10);
            }
        });
        return false;
    }

    startClustering(clusterData, type) {

        let $this = this;
        
        // Cria o array de objetos dataPoint
        var dataPoints = clusterData.map(function (item) {
            if(item.lat && item.lng){
                if(item.lat !== 0 && item.lng !== 0 && item.lat !== null && item.lng !== null){
                    let dataPoint = new H.clustering.DataPoint(item.lat, item.lng);
                    return dataPoint;
                }
            }
        });

        //remove os pontos vazios/null que ficariam no meio do mar
        dataPoints = dataPoints.filter(function(x) {
            return x !== undefined;
        });
   
        var clusteringOptions = {
            // Raio máximo da vizinhança
            eps: 32,
            // Peso mínimo de pontos pra formar um cluster
            minWeight: 5
          };

        var clusteredDataProvider = new H.clustering.Provider(dataPoints, clusteringOptions);

        // seta a cor do ícone dependendo do status
        var fgColor;
        var bgColor;
        switch(type){
            case "base":
                fgColor = "#3CA318";
                bgColor = "#2d7514";
                break;
            case "pending":
                fgColor = "#B3B3B3";
                bgColor = "#757575";
                break;
            case "in_transit":
                fgColor = "#FFC125";
                bgColor = "#99751c";
                break;
        }

        var customTheme = {
            getNoisePresentation: function(noisePoint) {
                // svg do caminhãozinho
                var noiseSvgTemplate =
                '<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<g filter="url(#filter0_d_205_1634)">' +
                '<circle cx="17" cy="16" r="14" fill="${fg_color}"/>' +
                '</g>' +
                '<g clip-path="url(#clip0_205_1634)">' +
                '<path fill-rule="evenodd" clip-rule="evenodd" d="M24.0442 10.666H16.9562C16.697 10.6723 ' +
                '16.4508 10.7811 16.2716 10.9685C16.0924 11.156 15.9948 11.4068 16.0002 11.666V11.9995H14V12.333H12.3333C11.4496 12.3341 10.6024 12.6856 9.97748 13.3105C9.35259 13.9354 9.00106 14.7826 9 15.6663V18.9997C9 19.3533 9.14048 19.6924 9.39052 19.9425C9.64057 20.1925 9.97971 20.333 10.3333 20.333H12.842C12.8653 20.3329 12.8883 20.328 12.9095 20.3185C12.9308 20.309 12.9499 20.2952 12.9655 20.278C12.9811 20.2607 12.9929 20.2404 13.0003 20.2183C13.0076 20.1962 13.0102 20.1728 13.008 20.1497C13.0033 20.1003 13 20.0503 13 19.9997C13 19.4959 13.1901 19.0107 13.5324 18.641C13.8746 18.2714 14.3437 18.0445 14.846 18.0057C14.8574 18.0048 14.8687 18.0027 14.8795 17.9995H16.0002V18.184C16.0002 18.2119 16.0072 18.2394 16.0206 18.2638C16.034 18.2883 16.0534 18.309 16.0769 ' +
                '18.324C16.3369 18.4895 16.555 18.713 16.7142 18.977C16.8733 19.2409 16.9692 19.5381 16.9942 19.8453C16.9976 19.8871 17.0165 19.9262 17.0472 19.9547C17.0779 19.9832 17.1183 19.9991 17.1602 19.9993H19.5069C19.5489 19.9993 19.5893 19.9834 19.62 19.9549C19.6508 19.9263 19.6697 19.8872 19.6729 19.8453C19.7119 19.3432 19.9388 18.8743 20.3085 18.5322C20.6781 18.1902 21.1632 18.0002 21.6669 18.0002C22.1705 18.0002 22.6556 18.1902 23.0253 18.5322C23.3949 18.8743 23.6219 19.3432 23.6609 19.8453C23.6642 19.8871 23.6831 19.9262 23.7139 19.9547C23.7446 19.9832 23.7849 19.9991 23.8269 19.9993H24.6669C24.7553 19.9993 24.8401 19.9642 24.9026 19.9017C24.9651 19.8392 25.0002 19.7544 25.0002 19.666V11.666C25.0056 11.4068 24.908 11.156 24.7288 10.9685C24.5496 10.7811 24.3034 10.6723 24.0442 10.666ZM12.3333 13.6663H13.5C13.5442 13.6663 13.5866 13.6839 13.6179 13.7152C13.6491 13.7464 13.6667 13.7888 13.6667 13.833V15.4997C13.6667 15.5439 13.6491 15.5863 13.6179 15.6175C13.5866 15.6488 13.5442 15.6663 13.5 15.6663H10.5073C10.4842 15.6663 10.4612 15.6615 10.44 15.6522C10.4188 15.6428 10.3998 15.6291 10.3842 15.612C10.3685 15.5949 10.3567 15.5747 10.3493 15.5527C10.3419 15.5307 10.3392 15.5074 10.3413 15.4843C10.3867 14.9874 10.6163 14.5254 10.9848 14.1891C11.3534 13.8527 11.8344 13.6663 12.3333 13.6663ZM16.3337 19.9993C16.3337 20.7357 15.7367 21.3327 15.0003 21.3327C14.2639 21.3327 13.667 20.7357 13.667 19.9993C13.667 19.263 14.2639 18.666 15.0003 18.666C15.7367 18.666 16.3337 19.263 16.3337 19.9993ZM21.6663 21.3327C22.4027 21.3327 22.9997 20.7357 22.9997 19.9993C22.9997 19.263 22.4027 18.666 21.6663 18.666C20.93 18.666 20.333 19.263 20.333 19.9993C20.333 20.7357 20.93 21.3327 21.6663 21.3327Z" fill="${bg_color}"/>' +
                '</g>' +
                '<defs>' +
                '<filter id="filter0_d_205_1634" x="0" y="0" width="34" height="34" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
                '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
                '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
                '<feOffset dy="1"/>' +
                '<feGaussianBlur stdDeviation="1.5"/>' +
                '<feComposite in2="hardAlpha" operator="out"/>' +
                '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>' +
                '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_205_1634"/>' +
                '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_205_1634" result="shape"/>' +
                '</filter>' +
                '<clipPath id="clip0_205_1634">' +
                '<rect width="16" height="16" fill="white" transform="translate(9 8)"/>' +
                '</clipPath>' +
                '</defs>' +
                '</svg>';
                
                var data = noisePoint.getData();

                var noiseIcon = new H.map.Icon(noiseSvgTemplate.replace('${fg_color}', fgColor).replace('${bg_color}', bgColor), {
                    size: {w: 25, h: 25},
                    anchor: {x: 12.5, y: 12.5}
                  });

                var noiseMarker = new H.map.Marker(noisePoint.getPosition(), 
                    {
                        icon: noiseIcon,
                        min: noisePoint.getMinZoom()
                    }
                );

                noiseMarker.setData(data);
            
                return noiseMarker;
            },
            getClusterPresentation: function (cluster) {
                // svg do círculo com o número dentro
                var clusterSvgTemplate =
                    '<svg xmlns="http://www.w3.org/2000/svg" height="50px" width="50px">' +
                    '<circle cx="25px" cy="25px" r="20" fill="${fg_color}" opacity="0.5" />' +
                    '<circle cx="25px" cy="25px" r="15" fill="${fg_color_2}" />' +
                    '<text x="24" y="32" font-size="12pt" font-family="arial" font-weight="bold" text-anchor="middle" fill="white">{text}</text>' +
                    '</svg>';

                var randomDataPoint = getRandomDataPoint(cluster),
                data = randomDataPoint.getData();

                // Pega os valores dos clusters pra formar as bolinhas do tamanho/texto certo
                var svgString = clusterSvgTemplate.replace('{text}', + cluster.getWeight()).replace('${fg_color}', fgColor).replace('${fg_color_2}', fgColor);

                var w, h;
                var weight = cluster.getWeight();
                if (weight <= 6){
                    w = 30;
                    h = 30;
                }else if (weight <= 12) {
                    w = 40;
                    h = 40;
                }else {
                    w = 60;
                    h = 60;
                }

                var clusterIcon = new H.map.Icon(svgString, {
                    size: { w: w, h: h },
                    anchor: { x: (w/2), y: (h/2) }
                });

                // cria os markers
                var clusterMarker = new H.map.Marker(cluster.getPosition(), {
                    icon: clusterIcon,
                    // seta os valores para o zoom sair ou não do cluster e mostrar os pontos
                    min: cluster.getMinZoom(),
                    max: cluster.getMaxZoom()
                });

                clusterMarker.setData(data);

                return clusterMarker;
            }
          };

        clusteredDataProvider.setTheme(customTheme);

        var clusteringLayer = new H.map.layer.ObjectLayer(clusteredDataProvider);

        $this.map.addLayer(clusteringLayer);
      }
}

// function toggleMapCaption(){
//     $("#map_infos").toggle("slow");
// }


//Função que gera o mapa da here no id passado
// function loadMap(lat_param, long_param, div_map_id, marker = 'stop', showInfo = true){

//     // if(lat_param && long_param && div_map_id){
//         let map_here = new Here();
//         map_here.createMap(div_map_id);
//         map_here.createControllers();
//         let coords = [];
//         coords.push({lat: lat_param, lng: long_param});
//         map_here.plotMarkers(coords, marker, showInfo);

//         if(map_here.coords.length > 0){
//             map_here.centerMap(map_here.coords);            
//         }
//     // }
// }

function getRandomDataPoint(cluster) {
    var dataPoints = [];
    cluster.forEachDataPoint(dataPoints.push.bind(dataPoints));
    return dataPoints[Math.random() * dataPoints.length | 0];
}